import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { apexQueryKeys } from "./queryKeys";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { ICRMBranch } from "./../../models/crm/CRMBranch";

export function useApexBranches(agencyId: string) {
  const { get } = useApiHelper();

  const branches = useQuery({
    queryKey: apexQueryKeys.branches(agencyId),
    queryFn: () =>
      get(
        `/integration/apex/branches/${agencyId}`
      ) as unknown as IDefaultResponseWithData<ICRMBranch[]>,
    refetchOnWindowFocus: false,
  });

  return {
    branches,
  };
}
